module.exports = __webpack_public_path__ + "static/media/3_xs.38780512.png";